export const decimals: number = 4;
export const denomination: number = 18;
export const erdLabel = "EGLD";
